// Pipefitter Redux — namespaced to avoid clashes with Data 360 reducers

// Project
export const PIPEFITTER_PROJECT_LOADER_START = '@@pipefitter/project/startLoader';
export const PIPEFITTER_PROJECT_LOADER_STOP = '@@pipefitter/project/stopLoader';
export const PIPEFITTER_SET_PROJECT_LIST = '@@pipefitter/project/setProjectList';
export const PIPEFITTER_SET_SELECTED_PROJECT = '@@pipefitter/project/setSelectedProject';
export const PIPEFITTER_SET_PIPE_COUNT = '@@pipefitter/project/setPipeCount';
export const PIPEFITTER_SET_TOTAL_PIPE_COUNT = '@@pipefitter/project/setTotalPipeCount';
export const PIPEFITTER_SET_USED_PIPE_COUNT = '@@pipefitter/project/setUsedPipeCount';
export const PIPEFITTER_SET_SPREAD_PIPE_COUNT = '@@pipefitter/project/setSpreadPipeCount';
export const PIPEFITTER_SET_SUBSPREAD_PIPE_COUNT = '@@pipefitter/project/setSubSpreadPipeCount';
export const PIPEFITTER_FETCH_PIPE_LENGTH = '@@pipefitter/project/fetchPipeLength';
export const PIPEFITTER_FETCH_PROJECT_LIST = '@@pipefitter/project/fetchProjectList';
export const PIPEFITTER_SET_MEAN_MAX_CALCULATION_STATUS =
  '@@pipefitter/project/setMeanMaxCalculationStatus';

// Configuration
export const PIPEFITTER_SET_CONFIGURATION_LOADING = '@@pipefitter/configuration/setLoading';
export const PIPEFITTER_SET_CONFIGURATION_LIST = '@@pipefitter/configuration/setList';
export const PIPEFITTER_GET_CONFIGURATION = '@@pipefitter/configuration/get';
export const PIPEFITTER_FETCH_SEQUENCE_CONFIGURATION = '@@pipefitter/configuration/fetchSequence';
export const PIPEFITTER_CREATE_SPREAD_CONFIGURATION = '@@pipefitter/configuration/createSpread';
export const PIPEFITTER_UPDATE_SPREAD_CONFIGURATION = '@@pipefitter/configuration/updateSpread';
export const PIPEFITTER_DELETE_SPREAD_CONFIGURATION = '@@pipefitter/configuration/deleteSpread';
export const PIPEFITTER_CREATE_SUB_SPREAD_CONFIGURATION = '@@pipefitter/configuration/createSubSpread';
export const PIPEFITTER_UPDATE_SUB_SPREAD_CONFIGURATION = '@@pipefitter/configuration/updateSubSpread';
export const PIPEFITTER_DELETE_SUB_SPREAD_CONFIGURATION = '@@pipefitter/configuration/deleteSubSpread';
export const PIPEFITTER_SORT_SPREAD_CONFIGURATION = '@@pipefitter/configuration/sortSpread';
export const PIPEFITTER_SORT_SUB_SPREAD_CONFIGURATION = '@@pipefitter/configuration/sortSubSpread';

// Sequence
export const PIPEFITTER_FETCH_SEQUENCE_CONFIGURATION_LIST = '@@pipefitter/sequence/fetchList';
export const PIPEFITTER_GENERATE_SEQUENCE_CONFIGURATION_LIST = '@@pipefitter/sequence/generate';
export const PIPEFITTER_PIPE_BASED_GENERATE_SEQUENCE = '@@pipefitter/sequence/pipeBasedGenerate';
export const PIPEFITTER_UPDATE_SPREAD_NAME = '@@pipefitter/sequence/updateSpreadName';
export const PIPEFITTER_DELETE_SEQUENCE_SPREAD = '@@pipefitter/sequence/delete';
export const PIPEFITTER_FETCH_SEQUENCE_REPORT = '@@pipefitter/sequence/fetchReport';
export const PIPEFITTER_APPROVE_SEQUENCE_SPREAD = '@@pipefitter/sequence/approve';
export const PIPEFITTER_SEND_EMAIL_SEQUENCE = '@@pipefitter/sequence/sendEmail';
export const PIPEFITTER_MIN_MAX_CALCULATION = '@@pipefitter/sequence/minMaxCalculation';
export const PIPEFITTER_SET_SEQUENCE_LIST = '@@pipefitter/sequence/setList';
export const PIPEFITTER_SET_SEQUENCE_LOADING = '@@pipefitter/sequence/setLoading';
export const PIPEFITTER_SET_SEQUENCE_LOADING_MORE = '@@pipefitter/sequence/setLoadingMore';

// Reports
export const PIPEFITTER_SET_REPORTS_LOADING = '@@pipefitter/reports/setLoading';
export const PIPEFITTER_SET_PIPE_STATISTICS = '@@pipefitter/reports/setPipeStatistics';
export const PIPEFITTER_SET_PIPE_STATUS = '@@pipefitter/reports/setPipeStatus';
export const PIPEFITTER_SET_PIPE_STATUS_PAGINATION = '@@pipefitter/reports/setPipeStatusPagination';
export const PIPEFITTER_SET_PIPE_STATUS_LOADING_MORE = '@@pipefitter/reports/setPipeStatusLoadingMore';
export const PIPEFITTER_SET_PIPE_DATA_GRAPH = '@@pipefitter/reports/setPipeDataGraph';
export const PIPEFITTER_SET_PROJECT_STATUS_PIPE_DATA = '@@pipefitter/reports/setProjectStatusPipeData';
export const PIPEFITTER_SET_PROJECT_SUMMARY_DATA = '@@pipefitter/reports/setProjectSummaryData';
export const PIPEFITTER_SET_PIPES_LIST_FILTERED = '@@pipefitter/reports/setPipesListFiltered';
export const PIPEFITTER_FETCH_PIPE_STATISTICS = '@@pipefitter/reports/fetchPipeStatistics';
export const PIPEFITTER_FETCH_PIPE_STATUS = '@@pipefitter/reports/fetchPipeStatus';
export const PIPEFITTER_FETCH_PIPE_DATA_GRAPH = '@@pipefitter/reports/fetchPipeDataGraph';
export const PIPEFITTER_FETCH_PROJECT_SUMMARY_DATA = '@@pipefitter/reports/fetchProjectSummaryData';
export const PIPEFITTER_FETCH_PROJECT_STATUS_PIPE_DATA = '@@pipefitter/reports/fetchProjectStatusPipeData';
export const PIPEFITTER_FETCH_PROJECT_REPORT = '@@pipefitter/reports/fetchProjectReport';
export const PIPEFITTER_FETCH_PROJECT_SUMMARY_REPORT = '@@pipefitter/reports/fetchProjectSummaryReport';
export const PIPEFITTER_SEND_EMAIL_PIPE_DATA = '@@pipefitter/reports/sendEmailPipeData';
export const PIPEFITTER_SEND_EMAIL_PROJECT_SUMMARY = '@@pipefitter/reports/sendEmailProjectSummary';
export const PIPEFITTER_ASSIGN_PIPE_STATUS_DATA = '@@pipefitter/reports/assignPipeStatusData';
export const PIPEFITTER_CREATE_UPDATE_PIPE_DATA = '@@pipefitter/reports/createUpdatePipeData';
export const PIPEFITTER_DELETE_PIPE_DATA = '@@pipefitter/reports/deletePipeData';
export const PIPEFITTER_UPDATE_PIPE_STATUS = '@@pipefitter/reports/updatePipeStatus';
export const PIPEFITTER_GENERATE_REPORT_PIPE_DATA = '@@pipefitter/reports/generateReportPipeData';
export const PIPEFITTER_GENERATE_REPORT_PIPE_DATA_PIPEWISE =
  '@@pipefitter/reports/generateReportPipeDataPipewise';
export const PIPEFITTER_GENERATE_REPORT_PROJECT_SUMMARY = '@@pipefitter/reports/generateReportProjectSummary';
export const PIPEFITTER_GET_ALL_PIPE_DATA = '@@pipefitter/reports/getAllPipeData';
export const PIPEFITTER_TRIGGER_REPORT_COMPLIMENTARY = '@@pipefitter/reports/triggerReportComplimentary';

// Uploads
export const PIPEFITTER_SET_INVALID_FILES = '@@pipefitter/uploads/setInvalidFiles';
export const PIPEFITTER_UPLOAD_JSON_FILES = '@@pipefitter/uploads/uploadJsonFiles';

// Random pipe compatibility report
export const PIPEFITTER_RANDOM_COMPAT_SUBMIT = '@@pipefitter/randomCompat/submit';
export const PIPEFITTER_RANDOM_COMPAT_RESET = '@@pipefitter/randomCompat/reset';
export const PIPEFITTER_RANDOM_COMPAT_SET_STATE = '@@pipefitter/randomCompat/setState';
